import { render, staticRenderFns } from "./AppSettingsMenu.vue?vue&type=template&id=f48d227c&scoped=true"
import script from "./AppSettingsMenu.vue?vue&type=script&lang=js"
export * from "./AppSettingsMenu.vue?vue&type=script&lang=js"
import style0 from "./AppSettingsMenu.vue?vue&type=style&index=0&id=f48d227c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48d227c",
  null
  
)

export default component.exports